/**
 * Created by rouven on 16.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import DataProvider from '@wikom/wikom-data';
import { useRoute } from '@app/router';
var Content = function (_a) {
    var data = _a.data, divClassName = _a.divClassName;
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: data }, className: divClassName });
};
var CmsContent = function (_a) {
    var page = _a.page, className = _a.className, onlyLoaded = _a.onlyLoaded;
    var ROUTE = useRoute();
    return (React.createElement(DataProvider, { name: 'cms_' + page, url: ROUTE.API.CMS({ page: page }), onlyLoaded: onlyLoaded },
        React.createElement(Content, { divClassName: className })));
};
CmsContent.propTypes = {
    page: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired
};
CmsContent.defaultProps = {
    className: undefined,
    onlyLoaded: false,
};
export default CmsContent;
